module.exports = "<nv-react-component component=\"LearningJourneys\"></nv-react-component>";